import { RoutesType } from "entities/common";
import LayoutLogin from "layout/LayoutLogin";
import LayoutMain from "layout/LayoutMain";
import { PAGES } from "utils/links";
import { RequireAdmin } from "widgets/RequireAdmin";
import { RequireIaqLimitAccess } from "widgets/RequireIaqLimitAccess";

import HomePage from "./Home";

import AcceptInvitationPage from "./AcceptInvitation";
import AssetsPage from "./Assets";
import AssetDetailPage from "./Assets/Detail";
import ChartsPage from "./Charts";
import CompanyDetailPage from "./Companies/Detail";
import CompanyListPage from "./Companies/List";
import DevicesListPage from "./Devices/List";
import ErrorPage from "./ErrorPage";
import IncidentsListPage from "./Incidents/List";
import LoginPage from "./Login";
import PortfolioDetailPage from "./Portfolios/Detail";
import PortfolioListPage from "./Portfolios/List";
import ReportsPage from "./Reports";
import ResetPasswordPage from "./ResetPassword";
import SensorBreakdownPage from "./SensorBreakdown";
import SetNewPasswordPage from "./SetNewPassword";
import SettingsPage from "./Settings";
import GatewaysListPage from "./Settings/Gateways/List";
import IAQLimit from "./Settings/IAQLimit";
import NotificationsPage from "./Settings/Notifications";
import UsersPage from "./Users";

const clientRoutes: RoutesType[] = [
  {
    path: PAGES.LOGIN,
    element: <LoginPage />,
    name: "ViewLogin",
    Layout: LayoutLogin,
    isPrivate: false,
  },
  {
    path: PAGES.RESET_PASSWORD,
    element: <ResetPasswordPage />,
    name: "ViewResetPassword",
    Layout: LayoutLogin,
    isPrivate: false,
  },
  {
    path: PAGES.SET_NEW_PASSWORD,
    element: <SetNewPasswordPage />,
    name: "ViewSetNewPassword",
    Layout: LayoutLogin,
    isPrivate: false,
  },
  {
    path: PAGES.ACCEPT_INVITATION,
    element: <AcceptInvitationPage />,
    name: "ViewAcceptInvitation",
    Layout: LayoutLogin,
    isPrivate: false,
  },

  {
    path: PAGES.HOME,
    element: <HomePage />,
    name: "ViewHome",
    Layout: LayoutMain,
    isPrivate: true,
  },
  {
    path: PAGES.PORTFOLIOS_LIST,
    element: <PortfolioListPage />,
    name: "ViewPortfolioList",
    Layout: LayoutMain,
    isPrivate: true,
  },
  {
    path: PAGES.PORTFOLIO_DETAIL,
    element: <PortfolioDetailPage />,
    name: "ViewPortfolioDetail",
    Layout: LayoutMain,
    isPrivate: true,
  },
  {
    path: PAGES.ASSETS_LIST,
    element: <AssetsPage />,
    name: "ViewAssets",
    Layout: LayoutMain,
    isPrivate: true,
  },
  {
    path: PAGES.ASSET_DETAIL,
    element: <AssetDetailPage />,
    name: "ViewAssetDetail",
    Layout: LayoutMain,
    isPrivate: true,
  },
  {
    path: PAGES.ASSET_PARAMETER_BREAKDOWN,
    element: <SensorBreakdownPage />,
    name: "ViewSensorBreakdown",
    Layout: LayoutMain,
    isPrivate: true,
  },
  {
    path: PAGES.CHARTS,
    element: <ChartsPage />,
    name: "ViewCharts",
    Layout: LayoutMain,
    isPrivate: true,
  },
  {
    path: PAGES.COMPANY_LIST,
    element: <CompanyListPage />,
    name: "ViewCompanyList",
    Layout: LayoutMain,
    isPrivate: true,
  },
  {
    path: PAGES.COMPANY_DETAIL,
    element: <CompanyDetailPage />,
    name: "ViewCompanyDetail",
    Layout: LayoutMain,
    isPrivate: true,
  },
  {
    path: PAGES.USERS,
    element: <UsersPage />,
    name: "ViewUsers",
    Layout: LayoutMain,
    isPrivate: true,
  },
  {
    path: PAGES.DEVICES_LIST,
    element: <DevicesListPage />,
    name: "ViewDevicesList",
    Layout: LayoutMain,
    isPrivate: true,
  },
  {
    path: PAGES.INCIDENTS_LIST,
    element: <IncidentsListPage />,
    name: "ViewIncidentsList",
    Layout: LayoutMain,
    isPrivate: true,
  },
  {
    path: PAGES.REPORTS,
    element: <ReportsPage />,
    name: "ViewReports",
    Layout: LayoutMain,
    isPrivate: true,
  },
  {
    path: PAGES.SETTINGS,
    element: <SettingsPage />,
    name: "ViewSettings",
    Layout: LayoutMain,
    isPrivate: true,
  },
  {
    path: PAGES.SETTINGS_NOTIFICATIONS,
    element: <NotificationsPage />,
    name: "ViewSettingsNotifications",
    Layout: LayoutMain,
    isPrivate: true,
  },
  {
    path: PAGES.SETTINGS_GATEWAYS_LIST,
    element: (
      <RequireAdmin>
        <GatewaysListPage />
      </RequireAdmin>
    ),
    name: "ViewSettingsGatewaysList",
    Layout: LayoutMain,
    isPrivate: true,
  },
  {
    path: PAGES.SETTINGS_IAQ_LIMIT_SETTINGS,
    element: (
      <RequireIaqLimitAccess>
        <IAQLimit />
      </RequireIaqLimitAccess>
    ),
    name: "ViewSettingsIAQLimit",
    Layout: LayoutMain,
    isPrivate: true,
  },

  {
    path: "*",
    element: <ErrorPage />,
    name: "ViewNotFound",
    Layout: LayoutMain,
    isPrivate: false,
  },
];

export default clientRoutes;
